import { render, staticRenderFns } from "./vueSwiper_shopImg.vue?vue&type=template&id=119d12ad&scoped=true&"
import script from "./vueSwiper_shopImg.vue?vue&type=script&lang=js&"
export * from "./vueSwiper_shopImg.vue?vue&type=script&lang=js&"
import style0 from "./vueSwiper_shopImg.vue?vue&type=style&index=0&id=119d12ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119d12ad",
  null
  
)

export default component.exports